import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CorePipesModule } from '@core/pipes/core-pipes.module';
import { DragAndDropManagerModule } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager.module';
import { MatMenuModule } from '@angular/material/menu';
import { DragAndDropManagerService } from '@core/modules/drag-and-drop-manager/drag-and-drop-manager.service';
import { NavigationComponent } from './navigation.component';
import { ListItemComponent } from './list-item/list-item.component';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [
        NavigationComponent,
        ListItemComponent,
    ],
    imports: [
        FuseSharedModule,
        SharedModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatIconModule,
        MatDividerModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        DragDropModule,
        CorePipesModule,
        DragAndDropManagerModule,
        MatMenuModule,
        TranslationModule,
    ],
    exports: [
        NavigationComponent,
        ListItemComponent,
    ],
    providers: [
        DragAndDropManagerService,
    ]
})
export class NavigationSharedModule {
}
